import * as React from 'react';
import autobind from "autobind-decorator";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { resolve } from "inversify-react";

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from "src/core/services/ui/dialog.service";
import { ClientGDPRListView } from './client-gdpr-list.view';
import { ClientGDPRSummaryDataService } from './client-gdpr.data';
import { FormatService } from 'src/core/services/format.service';

@observer
export class ClientGDPRListController extends React.Component<ControllerProps<any>, any> {
	
    @observable
	protected dataService: ClientGDPRSummaryDataService;
	@resolve
	formatService: FormatService
    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
		this.dataService = ClientGDPRSummaryDataService.make();
    }

   

	public componentDidMount() {
		
        this.loadData();
    }

    @autobind
    protected onItemEdit(clientId: number ) {
		this.props.history.push(`/crm/gdpr/${clientId}`);
    }

    @autobind
    protected loadData() {
        this.props.setBusy(true);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addFilter('type', 'eq', 0);
        this.dataService.load(query => query)
            .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false);
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return <ClientGDPRListView
			model={this.dataService}
			formatService={this.formatService}
			setBusy={this.props.setBusy} onItemEdit={this.onItemEdit} {...this.props} />
    }
}



// WEBPACK FOOTER //
// ./src/app/gdpr/clients/list/client-gdpr-list.controller.tsx